export const InfoIcon = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<circle cx="8" cy="8" r="6.6" stroke="currentColor" strokeWidth="1.3" />
			<path d="M8 7.2v4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
			<circle cx="8" cy="4.9" r=".9" fill="currentColor" />
		</svg>
	)
}
